<template>
  <div class="search-section input-group">
    <div class="search-input-wrapper input-group-prepend">
      <span class="input-group-text" id="search-icon">
        <v-icon name="search" style="height: 16px; width: 16px; stroke: #5a5c5c; opacity: 0.49;"></v-icon>
      </span>
      <input
        type="text"
        class="search-input form-control"
        v-model="searchKeywords"
        :placeholder="placeholder"
        @focus="toggleDropdown(true)"
        @blur="toggleDropdown(false)"
        @keydown.down="scrollSearchResult('down')"
        @keydown.up="scrollSearchResult('up')"
        @keydown.enter.prevent="selectSearchTicker(searchKeywords)"
        @keyup="searchTag"
        aria-describedby="search-icon"
        aria-label="searchAssets"
      />
    </div>

    <div class="dropdown-content-wrapper" v-show="showDropdown">
      <div class="dropdown-content">
        <!-- search results -->
        <div v-for="(option, index) in searchResults" :key="index">
          <div
            class="dropdown-item row"
            @mousedown.prevent="selectSearchTicker(option)"
            @mouseover="searchSelection = index"
            :style="index == searchSelection ? 'background-color: #e7ecf5;': ''"
          >
            <p class="col-4">{{option.ticker}}</p>
            <p class="col-8">{{option.name | shorten(25)}}</p>
          </div>
        </div>

        <hr class="divider" />

        <!-- recent search history -->
        <div class="recent-search">
          <p>
            <v-icon name="clock"></v-icon>&nbsp;Recent Search
          </p>

          <div v-for="(opt, idx) in recentSearch" :key="idx">
            <div class="dropdown-item row" @mousedown.prevent="selectSearchTicker(opt)">
              <p class="col-4">{{opt.ticker}}</p>
              <p class="col-8">{{opt.name | shorten(25)}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { debounce } from "lodash";

export default {
  name: "AssetSearch",

  props: {
    placeholder: {
      type: String,
      required: false,
      default: "Search for Tickers or Assets Name",
      note: "Placeholder of dropdown"
    },
    maxSearchResultItem: {
      type: Number,
      required: false,
      default: 4,
      note: "Max items showing"
    },
    maxRecentSearchItem: {
      type: Number,
      required: false,
      default: 3,
      note: "Max items showing"
    }
  },

  data() {
    return {
      searchKeywords: "",
      searchSelection: 0,
      searchResults: [],

      showDropdown: false,
      oldInput: ""
    };
  },

  computed: {
    recentSearch() {
      const recentSearch = this.getWindowLocalStorage("search");
      return recentSearch ? JSON.parse(recentSearch) : [];
    }
  },

  methods: {
    toggleDropdown(show) {
      this.showDropdown = show;
    },

    scrollSearchResult(direction) {
      if (direction === "up")
        this.searchSelection = Math.max(0, this.searchSelection - 1);
      else
        this.searchSelection = Math.min(
          this.searchSelection + 1,
          this.searchResults.length - 1
        );
    },

    updateRecentSearch(option) {
      let recentSearch = this.getWindowLocalStorage("search");

      if (recentSearch) {
        recentSearch = JSON.parse(recentSearch);
        recentSearch = recentSearch.filter(el => el.ticker != option.ticker);
        if (recentSearch.length == this.maxRecentSearchItem) {
          recentSearch.shift();
        }
        recentSearch.push(option);
      } else {
        recentSearch = [option];
      }
      this.setWindowLocalStorage("search", JSON.stringify(recentSearch));
    },

    selectSearchTicker(option) {
      // user select from recent search
      if (option && option.ticker) {
        console.log("[asset-search] selectSearchTicker() option is: ", option);
        this.$emit("selectSearchTicker", option);
      } else if (this.searchResults.length && this.searchSelection >= 0) {
        const selection = this.searchResults[this.searchSelection];
        console.log(
          "[asset-search] selectSearchTicker() selection is: ",
          this.searchResults,
          this.searchSelection
        );
        this.searchKeywords = selection.ticker;
        this.$emit("selectSearchTicker", selection);
        this.updateRecentSearch(selection);
      }

      this.toggleDropdown(false);
    },

    searchTag: debounce(function() {
      if (
        this.oldInput != this.searchKeywords ||
        this.searchResults.length == 0
      ) {
        this.searchResults = [];
      } else return;
      const input = this.searchKeywords.trim();
      if (!input) return;
      this.$store
        .dispatch("elaticSearchForAssets", input)
        .then(res => res.json())
        .then(res => {
          res.sort((a, b) => a.ticker.length - b.ticker.length);
          let equal;
          let start = 0;
          // put the results which name equals search name in the first row
          if (input.includes(" ")) {
            equal = res.filter(el =>
              el.companyName.toLowerCase().includes(input.toLowerCase())
            )[0];
          } else {
            equal = res.filter(
              el => el.ticker.toLowerCase() === input.toLowerCase()
            )[0];
          }

          if (equal) {
            this.addRearchResult(equal);
            start = 1;
          }

          for (let index = start; index < this.maxSearchResultItem; index++) {
            // console.log(res);
            const el = res[index];
            // console.log(el);
            this.addRearchResult(el);
          }
        })
        .catch(err => {
          console.log("searchTag() ERROR is: ", err);
        });
      this.oldInput = input;
    }, 125),

    addRearchResult(el) {
      let { companyName, ticker, exchange } = el;
      companyName = companyName === "nan" ? "" : companyName;
      this.searchResults.push({ ticker, name: companyName, exchange });
    }
  }
};
</script>


<style scoped>
.search-section {
  display: flex;
  position: relative;
  align-items: center;
  border-bottom: solid 0.4px #979797;
  z-index: 99;
}

.search-input-wrapper {
  width: 100%;
  background-color: #16abbd;
  padding: 0.5rem 1rem 0.5rem;
}

#search-icon {
  background-color: white;
  border-right: none;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.search-input {
  border-left: none;
  background-clip: unset;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.search-input:focus {
  box-shadow: none;
}

.icon-clock {
  height: 1rem;
  width: 1rem;
  stroke: #5a5c5c;
  margin-bottom: 0.25rem;
  opacity: 0.8;
}

/* Dropdown Content Styling */

.dropdown-content-wrapper {
  position: absolute;
  top: 2.8rem;
  width: 100%;
}

.dropdown-content {
  background-color: #fff;
  width: calc(100% - 2rem);
  padding: 1rem;
  margin: 0 1rem;
  border: 1px solid #e7ecf5;
  border-radius: 6px;
  box-shadow: 0 0 26px -2px #f1f1f1;
  overflow: auto;
  z-index: 100;
}

.dropdown-item {
  display: flex;
  color: black;
  font-size: 0.7em;
  padding: 0.2rem 0;
  margin: 0;
  cursor: pointer;
}

.dropdown-item-hightlight {
  background-color: #e7ecf5;
}

.divider {
  margin: 0.5rem 0;
  border: 0.6px solid #a4a4a4;
}

@media (min-width: 768px) {
  .search-input-wrapper,
  .dropdown-content-wrapper {
    padding-left: 10rem;
    padding-right: 10rem;
  }

  .dropdown-content-wrapper {
    margin: 0;
  }

  .search-input {
    max-width: 28rem;
  }

  .dropdown-content {
    width: 100%;
    max-width: 30.5rem;
    margin: 0;
  }
}

@media (min-width: 992px) {
  .search-input-wrapper,
  .dropdown-content-wrapper {
    padding-left: 15rem;
    padding-right: 15rem;
  }

  .search-input {
    max-width: 34rem;
  }

  .dropdown-content {
    max-width: 36.5rem;
  }
}

@media (min-width: 1200px) {
  .search-input-wrapper,
  .dropdown-content-wrapper {
    padding-left: 20rem;
    padding-right: 20rem;
  }

  .search-input {
    max-width: 38rem;
  }

  .dropdown-content {
    max-width: 40.5rem;
  }

  .dropdown-item {
    font-size: 0.9rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/utils/asset-search.vue